import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/vehicles_/add')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('vehicles:manage')) {
      throw redirect({ to: '/vehicles' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/identity-page')),
  staticData: { titleKey: 'addVehicle' },
});
